import moment from "moment";
import React, { useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useReactToPrint } from "react-to-print";
import useSWR from "swr";
import { API } from "../../../StoreComponents/conflict";

const fetcher = (url) => API.get(url).then((res) => res.data.data);
const LogsMonthly = () => {
  const [openElement, setOpenElement] = useState(false);
  const [printButton, setPrintButton] = useState(false);
  const [monthDate, setMonthDate] = useState("");
  const [yearDate, setYearDate] = useState("");
  const [typeError, setTypeError] = useState("");

  // get Enties All Product Data
  let presentYear = new Date().getFullYear();
  let yearMap = [];
  for (let i = 2022; i <= presentYear; i++) {
    yearMap.push(i);
  }

  const {
    data: allEnties,
    error,
    mutate,
  } = useSWR(
    monthDate && yearDate
      ? `store/reports/productlogs?queryFor=month&month=${monthDate}&year=${yearDate}`
      : null,
    fetcher
  );
  //console.log(allEnties);
  // toggle seach button
  const handleToggle = () => {
    if (!monthDate || !yearDate) {
      setTypeError("field Required");
      setOpenElement(false);
      setPrintButton(false);
    } else {
      setOpenElement(true);
      setPrintButton(true);
    }
  };
  //console.log("month", monthDate, "year", yearDate);
  // console.log("year",presentYear);

  // print
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (
    <>
      <Helmet>
        <title>All Products - BBA STORE</title>
        <meta name="description" content="Product List - BBA STORE" />
      </Helmet>{" "}
      <style type="text/css">{"label{font-size:1rem !important}"}</style>
      <div className="page-wrapper">
        <div className="content container-fluid main-container">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-start text-dark">Search Logs By Month Wise</h3>
            <button
              onClick={handlePrint}
              type="button"
              className={
                printButton
                  ? "btn btn-color px-3 printBtn show"
                  : "printBtn btn btn-danger px-3"
              }
            >
              <i className="fa fa-print"></i>
              <span> Print</span>
            </button>
          </div>

          {/* Seach Element */}
          <div className="category show">
            <div className="mx-auto">
              <div className="add_category text-center">
                <div className="row mx-3">
                  <div className="col-12 col-md-4 col-lg-4">
                    <label htmlFor="From_Date" className="text-start">
                      Month
                    </label>
                    <select
                      className="form-select input-field-existing fs-6"
                      aria-label="Default select example"
                      onChange={(e) => {
                        setMonthDate(e.target.value);
                      }}
                    >
                      <option selected>Select Month</option>
                      <option value="January">January</option>
                      <option value="February">February</option>
                      <option value="March">March</option>
                      <option value="April">April</option>
                      <option value="May">May</option>
                      <option value="June">June</option>
                      <option value="July">July</option>
                      <option value="August">August</option>
                      <option value="September">September</option>
                      <option value="October">October</option>
                      <option value="November">November</option>
                      <option value="December">December</option>
                    </select>
                    {/* <input onChange={e => { setMonthDate(e.target.value) }}  type="month" name="From_Date" className='p-2 input-field' /> */}
                    <p className="text-start text-danger">
                      {monthDate ? "" : typeError}
                    </p>
                  </div>
                  <div className="col-12 col-md-4 col-lg-4">
                    <label htmlFor="To_Date">Year</label>
                    <select
                      className="form-select input-field-existing fs-6"
                      aria-label="Default select example"
                      onChange={(e) => {
                        setYearDate(e.target.value);
                      }}
                    >
                      <option selected>Select Year</option>
                      {yearMap &&
                        yearMap.map((product) => (
                          <option value={product}>{product}</option>
                        ))}
                    </select>

                    <p className="text-start text-danger">
                      {yearDate ? "" : typeError}
                    </p>
                  </div>
                </div>
                <br />
                <button
                  onClick={handleToggle}
                  type="button"
                  className="mt-3 px-5 btn btn-color_store"
                >
                  <i className="fa fa-search"></i>
                  <span> Search</span>
                </button>
              </div>

              {/* Search Result */}
              {allEnties ? (
                <div
                  ref={componentRef}
                  className={
                    openElement
                      ? "category show my-4 table-container p-2"
                      : "category my-4 table-container p-2"
                  }
                  style={{ background: "white", borderRadius: "10px" }}
                >
                  <div className="text-center mt-4 mb-5">
                    <div>
                      <h4>
                        <b>INFOTECH IT SOLUTIONS</b>
                      </h4>
                     
                      <h3>দ্রব্য লগ</h3>
                      <h5>
                        ( {allEnties.summMonth ? allEnties.summMonth : ""} )
                      </h5>
                    </div>
                  </div>
                  <div className="table-responsive-sm">
                    <table className="table table-bordered table-striped boder">
                      <thead>
                        <tr className="text-center">
                          <th className=" col-design1" colSpan="1">
                            S/N
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Date
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Category
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Product
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Initial
                          </th>
                          <th className=" col-design1" colSpan="1">
                            In
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Total
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Out
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Balance
                          </th>
                          <th className=" col-design1" colSpan="1">
                            Name
                          </th>
                        </tr>
                      </thead>
                      {allEnties.productSummaries && (
                        <tbody>
                          {allEnties.productSummaries.map((product, index) => (
                            <tr key={index}>
                              <th className=" col-design1">{index + 1}</th>
                              <td
                                className=" col-design1"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                {moment(new Date(product.SUMMDATE)).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td className="text-start col-design1">
                                {product.CATEGORYEN}
                              </td>
                              <td className="text-start col-design1">
                                {product.PRODUCTNAME}
                              </td>
                              <td className=" col-design1">
                                {product.INTIALQTY}
                              </td>
                              <td className=" col-design1">
                                {product.NEWADDQTY ? product.NEWADDQTY : 0}
                              </td>
                              <td className=" col-design1">
                                {product.TOTALBALANCE}
                              </td>
                              <td className=" col-design1">
                                {product.TOTALOUT ? product.TOTALOUT : 0}
                              </td>
                              <td className=" col-design1">
                                {product.PRESENTBALANCE}
                              </td>
                              <td className="text-start col-design1">
                                {product.NAME} <br /> {product.DESIGNATION}
                              </td>
                            </tr>
                          ))}
                          <tr>
                            <th className=" col-design1"></th>
                            <td className=" col-design1"></td>
                            <td className=" col-design1"></td>
                            <td className=" col-design1"></td>
                            <td className="fw-bold col-design1">
                              Grand Total IN
                            </td>
                            <td className=" col-design1">
                              {allEnties.totalIn}
                            </td>
                            <td className=" col-design1"></td>
                            <td className="fw-bold col-design1">
                              Grand Total OUT
                            </td>
                            <td className=" col-design1"></td>
                            <td className="fw-bold col-design1">
                              {allEnties.totalOut}
                            </td>
                          </tr>
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          {/* Seach Element */}
        </div>
      </div>
    </>
  );
};

export default LogsMonthly;
